import React from 'react';
import classNames from 'classnames';
import { abbrevNumberMaxLength } from '../../../common/utils';
var MAX_ALL_CHARACTERS = 48;
var HistogramXAxis = function (_a) {
    var labels = _a.labels, ticksBetweenBars = _a.ticksBetweenBars, hoveredBarIdx = _a.hoveredBarIdx;
    var maxCharsInLine = ticksBetweenBars ? MAX_ALL_CHARACTERS + 4 : MAX_ALL_CHARACTERS;
    var stringLabels = labels.map(function (label) { return typeof label === 'number' ? abbrevNumberMaxLength(label, 4).toString() : label; });
    var angledTicks = stringLabels.some(function (q) { return q.length > maxCharsInLine / labels.length; });
    // highlight single label if the ticks are under the bars and highlight two labels (one before, one after bar) if the ticks are between bars
    var highlightedLabelsIdx = hoveredBarIdx !== undefined
        ? ticksBetweenBars ? [hoveredBarIdx, hoveredBarIdx + 1] : [hoveredBarIdx]
        : [];
    return (React.createElement("div", { className: classNames('histogramXAxis', {
            'histogramXAxis--angledTicks': angledTicks,
            'histogramXAxis--ticksBetweenBars': ticksBetweenBars
        }) }, stringLabels.map(function (label, idx) {
        var barWidth = 100 / (labels.length) + "%";
        return (React.createElement("div", { className: classNames('histogramXAxis__labelWrapper', { 'histogramXAxis__labelWrapper--hover': highlightedLabelsIdx.includes(idx) }), key: label, style: { width: barWidth } },
            React.createElement("div", { className: "histogramXAxis__label" }, label)));
    })));
};
export default HistogramXAxis;
//# sourceMappingURL=HistogramXAxis.js.map